import { Box } from '@mui/material'
import { FC } from 'react'

export const InlineAsterisk: FC = () => {
  return <Box component='span' color='#EB3434'> *</Box>
}